import qs from "qs";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import MetaTag from "src/components/layout/MetaTag";
import useNavigate from "src/hooks/usePartnerNavigate";
import { partnersState } from "src/recoil/partners/atom";
import PagePath from "../../pagePath.json";
import PartnerBox from "./PartnerBox";

type PartnerCode = {
  partnerCode?: string;
};

const InitCtrlRoom = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const query: PartnerCode = useMemo(() => {
    return qs.parse(location.search, { ignoreQueryPrefix: true, allowDots: true });
  }, [location]);

  const partners = useRecoilValue(partnersState);

  const sortedPartnerList = [...(partners || [])].sort((a, b) => a.name.localeCompare(b.name));

  useEffect(() => {
    if (partners && query.partnerCode && query.partnerCode !== "") {
      let partner = partners.find((partner) => partner.code === query.partnerCode);
      if (!partner) {
        navigate(PagePath.accessDenied);
      } else {
        navigate(PagePath.main.replace(":partnerId", String(partner.id)));
      }
    }
  }, [query, partners]);

  if (!partners) return null;
  return (
    <>
      <MetaTag subTitle={"파트너 선택"} />
      <div className="page-init">
        <div className="page-init__bin"></div>
        <div className="page-init__contents">
          <h1>관리하실 파트너를 선택하세요</h1>

          {sortedPartnerList.length > 0 ? (
            <div className={`${sortedPartnerList.length > 4 ? "justify-content-start" : ""} partner-box-wrap`}>
              {sortedPartnerList.map((partner) => (
                <PartnerBox
                  key={partner.id}
                  title={partner.name}
                  subTitle={partner.code}
                  onClick={() => {
                    //
                    //recoil 파트너 id 저장
                    // setPartner(partner);
                    window.location.href = PagePath.main.replace(":partnerId", String(partner.id));
                    // const path = PagePath.main.replace(":partnerId", String(partner.id));
                    // navigate(path);
                  }}
                />
              ))}
            </div>
          ) : (
            <div className={"partner-box-wrap"}>
              <PartnerBox className="empty" title={"선택가능한 파트너가 없습니다"} />
            </div>
          )}
        </div>
        <div className="page-init__footer">
          <p className="only-pc">
            이용에 어려움이 있으신가요? <span>계약 담당자에게 권한을 요청해주세요</span>
          </p>
          <p className="only-mobile">
            이용에 어려움이 있으신가요?
            <br /> <span>계약 담당자에게 권한을 요청해주세요</span>
          </p>
        </div>
      </div>
    </>
  );
};

export default InitCtrlRoom;
